import { Box, Paper, Typography } from '@mui/material'
import './cover.scss'

const Cover = ({ t, theme, date, name, documentNumber, entity }) => {
  const report = entity === 'BUSINESS' ? t('common:reportCompany') : t('common:reportPerson')
  return (
    <div className={`kyb-cover ${theme}`}>
      <div className="kyb-cover-header">
        <Box className="kyb-gueno-logo">
          <img alt={'gueno-logo'} src={theme === 'light' ? '/logo-gueno-light2.png' : '/logo-gueno2.png'} />
        </Box>
      </div>
      <div className="kyb-cover-footer">
        <Box>
          <Typography variant="h3" style={{ color: 'white' }}>
            {report}
          </Typography>
          <Typography variant="h4" style={{ color: '#ecefed' }}>
            {date}
          </Typography>
        </Box>
        <Paper
          elevation={0}
          style={{
            backgroundColor: 'transparent',
            padding: '1rem',
            borderRadius: '.75rem',
            border: '1px dashed #ecefed',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
          }}
        >
          <Typography variant="h4" style={{ color: 'white' }}>
            {name}
          </Typography>
          <Typography variant="h5" style={{ color: 'white' }}>
            {documentNumber}
          </Typography>
        </Paper>
      </div>
    </div>
  )
}

export default Cover
